import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
//eslint-disable-next-line
import { css } from "styled-components/macro"; //eslint-disable-line

import { SectionHeading, Subheading as SubheadingBase } from "components/misc/Headings.js";
import { SectionDescription } from "components/misc/Typography.js";
import ResponsiveVideo from '../../helpers/ResponsiveVideoEmbed'

const Container = tw.div`relative -mt-6`;

const ThreeColumnContainer = styled.div`
  ${tw`flex flex-col items-center md:items-stretch md:flex-row flex-wrap md:justify-center max-w-screen-2xl mx-auto py-20 md:py-24`}
`;
const Heading = tw(SectionHeading)`w-full max-w-screen-sm text-center p-2`;
const Description = tw(SectionDescription)`w-full text-center max-w-screen-lg mt-0`;
const Subheading = tw(SubheadingBase)`w-full font-bold text-2xl text-center mb-4`;


const VerticalSpacer = tw.div`mt-10 w-full`

const Column = styled.div`
  ${tw`md:w-1/2 lg:w-1/3 flex flex-col justify-center`}
`;

const Card = styled.div`
  ${tw`flex justify-center sm:text-left h-full`}
  .imageContainer {
    ${tw``}
    img {
      ${tw``}
    }
  }

  .textContainer {
    ${tw`sm:ml-4 mt-4 sm:mt-2`}
  }

  .title {
    ${tw`font-semibold tracking-wide text-xl leading-none mb-8 uppercase`}
  }

  .description {
    ${tw`text-secondary-200 `}
  }
`;

const StyledResponsiveVideoEmbed = styled(ResponsiveVideo)`
  ${tw`rounded`}
  iframe {
    ${tw``}
  }
`;

export default ({
    heading = "", 
    description = "",
    urlVideo = null,
    cardsLeft = null,
    cardsRight = null
}) => {

  return (
    <Container>
      <ThreeColumnContainer>
        <Heading>{heading}</Heading>
        {description && <Description>{description}</Description>}
        <VerticalSpacer />
        <Column tw="max-w-xs p-2">
        {cardsLeft.map((card, i) => (
            <Card tw="sm:text-right pr-4" key={i}>
              <span className="textContainer">
                <span className="title"><a href={card.url}>{card.title}</a></span>
                <p className="description">
                  {card.description}
                </p>
              </span>
            </Card>
        ))}
        </Column>
        <Column>
          <StyledResponsiveVideoEmbed
            url={ urlVideo }
          />
        </Column>
        <Column tw="max-w-xs p-2">
        {cardsRight.map((card, i) => (
            <Card tw="sm:text-left" key={i}>
              <span className="textContainer">
                <span className="title"><a href={card.url}>{card.title}</a></span>
                <p className="description">
                  {card.description}
                </p>
              </span>
            </Card>
        ))}
        </Column>
      </ThreeColumnContainer>
    </Container>
  );
};
